import CustomerHandling from './CustomerHandling';

export default CustomerHandling;
